import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png';
import login_bg from '../assets/login_bg.jpg';
import logo_worded_only from '../assets/logo_worded_only.png';
import { callApi, CDN_URL, formatDate, formatMoney, getCookie, getInlineLoader, setCookie } from "../Helpers";
import { MdArrowCircleLeft, MdArrowCircleRight, MdCircle, MdLock, MdLogin, MdOutlinePhonelinkLock, MdPassword, MdPerson, MdPhone, MdPhoneAndroid, MdPhonelinkLock, MdPhoneLocked, MdWarningAmber } from "react-icons/md";
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaLocationArrow, FaUserDoctor } from "react-icons/fa6";
import { STR_AMOUNT, STR_AT_LEAST_ONE_IMAGE, STR_AVAILABLE_QUANTITY, STR_CANCEL_ORDER, STR_CANCELLATION_REASON, STR_CATEGORY, STR_COULD_NOT_FETCH_DATA, STR_CROPS, STR_DATE, STR_DELIVERY_LOCATION, STR_FROM_DESTINATION, STR_IMAGES, STR_INVALID_LOCATION, STR_INVALID_QUANTITY, STR_INVALID_TITLE, STR_INVALID_UNIT_PRICE, STR_ITEM_DESCRIPTION, STR_ITEM_LOCATION, STR_ITEM_TITLE, STR_LIVESTOCK, STR_MOQ, STR_OPTIONAL, STR_ORDER_NOTES, STR_ORDER_QUANTITY, STR_OVERALL_COST, STR_PACKAGING_COST, STR_PENDING, STR_PLACE_ORDER, STR_PLACE_YOUR_ORDER, STR_POST_ITEM, STR_REJECTED, STR_SHIPPING_COST, STR_STATUS, STR_SUBMIT, STR_SUCCESS, STR_TO_DESTINATION, STR_TOTAL_ORDER_PRICE, STR_TRANSACTION_FEES, STR_UNIT, STR_UNIT_PRICE, STR_VIEW_SALE, STR_VIEW_WITHDRAWAL_REQUEST, STR_WAITING_FOR_RIDER_TO_ACCEPT, STR_WITHDRAWAL_ACCOUNT_NAME, STR_WITHDRAWAL_ACCOUNT_NUMBER, STR_WITHDRAWAL_AMOUNT, STR_WITHDRAWAL_METHOD } from "../Strings";
import NapaAddressPicker from "../ones/NapaAddressPicker";
import ImageSlider from "../ones/ImagesSlider";
import OpSuccessWidget from "../ones/OpSuccessWidget";
import OrderInfo from "../ones/OrderInfo";
import OrderReceipt from "../ones/OrderReceipt";
import { FaMapMarkerAlt, FaWatchmanMonitoring } from "react-icons/fa";
import { AiOutlineWarning } from "react-icons/ai";
import { LuFileWarning, LuMailWarning } from "react-icons/lu";
import { CiWarning } from "react-icons/ci";


export default function ViewRideRequest({ uuid }) {

	const appContext = useContext(AppContext);

	const [loading, setLoading] = useState(false);
	const [ready, setReady] = useState(false);

	const [data, setData] = useState(null);
	

	async function init() {
		setReady(false);
		await Promise.all([
			getData(),
		])
		setReady(true)
	}

	

	async function getData() {
		await callApi("get-ride-request-data", { uuid }).then((response) => {
			if(response.status === 1) {
				setData(response.data);
			} else {
				appContext.tellError(STR_COULD_NOT_FETCH_DATA[appContext.language]);
			}
		})
	}

	

	useEffect(() => {
		init();
	}, [])

	

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
		
		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

	
	if (ready && data) {
		return (
			<div className="container py-3">

				{/* Summary */}
				<div
					className="p-4 rounded-4 mb-4 text-light bg-main-gradient mShadow3"
				>

					
					<h1
						className="font-light mNoMargin"
						style={{
							fontSize: "48px"
						}}
					>
						{Number(data.totalDistance).toFixed(2)}
					</h1>

					<h6
						className="font-regular"
						style={{
							fontSize: "16px"
						}}
					>
						Kilometers
					</h6>

					<hr />

					<h2
						className="font-bold mNoMargin"
					>
						{formatMoney(data.overallCost)}
					</h2>

					<h6
						className="font-light"
					>
						TZS
					</h6>

				</div>

				{/* Route */}
				<div
					className="card"
				>
					<div className="card-body">

						

						<div
							className="d-flex"
						>

							<FaLocationArrow
								size={22}
								className="text-primary flex-shrink-0 mt-1 me-3"
							/>

							<div>

								<div
									className="font-bold text-muted"
									style={{
										fontSize: "12px"
									}}
								>
									{STR_FROM_DESTINATION[appContext.language]}
								</div>

								<div
									className="font-regular"
								>
									{JSON.parse(data.fromDestination || "{}").description || "N/A"}
								</div>

							</div>

						</div>

						<div
							style={{
								height: "40px",
								width: "2px",
								background: "var(--secondaryColor)",
								marginLeft: "10px",
								marginTop: "8px",
								marginBottom: "8px",
								opacity: 0.3
							}}
						/>

						<div
							className="d-flex"
						>

							<FaMapMarkerAlt
								size={22}
								className="text-secondary flex-shrink-0 mt-1 me-3"
							/>

							<div>

								<div
									className="font-bold text-muted"
									style={{
										fontSize: "12px"
									}}
								>
									{STR_TO_DESTINATION[appContext.language]}
								</div>

								<div
									className="font-regular"
								>
									{JSON.parse(data.toDestination || "{}").description || "N/A"}
								</div>

							</div>

						</div>

					</div>
				</div>

				{/* Route */}
				<div
					className="card bg-secondary"
				>
					<div className="card-body">

						<h6
							style={{
								fontSize: "24px",
								padding: "20px"
							}}
							className="text-center font-light"
						>
							<CiWarning size={64}/>

							<br/>

							{STR_WAITING_FOR_RIDER_TO_ACCEPT[appContext.language]}
						</h6>

					</div>
				</div>

				{/* Statistics */}
				<div className="row">

					<div className="col-6">

						<div className="card">

							<div className="card-body text-center">

								<div
									className="text-muted font-bold"
									style={{
										fontSize: "12px"
									}}
								>
									DISTANCE
								</div>

								<h3
									className="font-bold text-primary mNoMargin"
								>
									{Number(data.totalDistance).toFixed(2)}
								</h3>

								<div
									className="text-muted"
								>
									KM
								</div>

							</div>

						</div>

					</div>

					<div className="col-6">

						<div className="card">

							<div className="card-body text-center">

								<div
									className="text-muted font-bold"
									style={{
										fontSize: "12px"
									}}
								>
									ESTIMATED COST
								</div>

								<h3
									className="font-bold text-secondary mNoMargin"
								>
									{formatMoney(data.overallCost)}
								</h3>

								<div
									className="text-muted"
								>
									TZS
								</div>

							</div>

						</div>

					</div>

				</div>

			</div>
		)
		
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}
	
}